import React from "react";
import { KeyboardAvoidingView, Platform } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import _ from "lodash";
import { ThemedValues } from 'styles/themed'
import isEqual from 'react-fast-compare'
import { layoutStyles } from 'styles/layout'


const ThemedKeyboardAvoidingView = ({ insetBottom = true, inScrollView = false, style = {}, children }) => {
	
	const insets = useSafeAreaInsets();
	
	let offset = 0;
	if( insetBottom ) {
		offset = _.get( insets, [ 'bottom' ], 0 );
		offset += ThemedValues.marginVertical;
	}
	
	const viewStyles = {
		height: '100%',
		...( inScrollView ? { flex: 1, width: '100%' } : {} )
	}
	
	return (
		<KeyboardAvoidingView
			behavior={ Platform.OS === 'ios' ? 'padding' : 'height' }
			contentContainerStyle={ layoutStyles.flexOne }
			keyboardVerticalOffset={ offset }
			style={ viewStyles }>
			
			{ children }
		</KeyboardAvoidingView>
	);
}

export default React.memo( ThemedKeyboardAvoidingView, isEqual );
